module.exports = __webpack_public_path__ + "img/03c_Store_651.cb63bc97.jpg";